
(()=> {
 const root=document.querySelector('.jptv-hero');
 if(!root || window.__jptvInitialized) return;
 window.__jptvInitialized=true;
 const nav=document.querySelector('[data-jptv-local-nav]');
 const links=nav?[...nav.querySelectorAll('a[href^="#"]')]:[];
 const targetIds=links.map(a=>a.getAttribute('href')).filter(x=>x && x.length>1);
 const setActive=id=>links.forEach(a=>{const hit=a.getAttribute('href')===id;a.classList.toggle('is-active',hit);if(hit)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 links.forEach(a=>a.addEventListener('click',event=>{
  const id=a.getAttribute('href');const section=document.querySelector(id);
  if(!section)return;
  event.preventDefault();
  const navSection=nav?nav.closest('[id^="shopify-section-"]'):null;
  const stickyTop=navSection?(parseFloat(getComputedStyle(navSection).top)||0):0;
  const offset=(nav?nav.offsetHeight:0)+stickyTop+8;
  const y=window.scrollY+section.getBoundingClientRect().top-offset;
  window.scrollTo({top:y,behavior:reduced?'auto':'smooth'});
  if(history.replaceState)history.replaceState(null,'',id);
  setActive(id);
  if(typeof window.gtag==='function')window.gtag('event','jptv_section_nav_click',{page_type:'jptv',section_id:id.replace('#','')});
 }));
 if('IntersectionObserver' in window){
  const observed=targetIds.map(id=>document.querySelector(id)).filter(Boolean);
  const io=new IntersectionObserver(entries=>{
   const visible=entries.filter(e=>e.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top);
   if(visible[0])setActive('#'+visible[0].target.id);
  },{rootMargin:'-15% 0px -60% 0px',threshold:0});
  observed.forEach(x=>io.observe(x));
 }
 const retailerMedia=window.matchMedia('(max-width: 767px)');
 const setResponsiveRetailerDefaults=(scope=document)=>{
  const sections=[];
  if(scope.matches?.('[data-jptv-stores-mode="responsive"]')) sections.push(scope);
  scope.querySelectorAll?.('[data-jptv-stores-mode="responsive"]').forEach(section=>sections.push(section));
  sections.forEach(section=>{
   section.querySelectorAll('details[data-jptv-store-group]').forEach(group=>{group.open=!retailerMedia.matches;});
  });
 };
 setResponsiveRetailerDefaults();
 if(retailerMedia.addEventListener) retailerMedia.addEventListener('change',()=>setResponsiveRetailerDefaults());
 else if(retailerMedia.addListener) retailerMedia.addListener(()=>setResponsiveRetailerDefaults());
 document.addEventListener('shopify:section:load',event=>setResponsiveRetailerDefaults(event.target));
 const mobileBuy=document.querySelector('[data-jptv-mobile-buy]');
 const buy=document.getElementById('buy');
 if(mobileBuy && buy && 'IntersectionObserver' in window){
  const io2=new IntersectionObserver(entries=>{mobileBuy.classList.toggle('is-hidden',entries.some(e=>e.isIntersecting))},{threshold:0.1});
  io2.observe(buy);
 }
 document.querySelectorAll('[data-jptv-outbound]').forEach(anchor=>anchor.addEventListener('click',()=>{
  const data={page_type:'jptv',campaign:'dental_tv_jp',retailer:anchor.dataset.retailer||'',model:anchor.dataset.model||'',destination_url:anchor.href};
  if(typeof window.gtag==='function'){window.gtag('event','jptv_retailer_click',data)}
  else if(Array.isArray(window.dataLayer)){window.dataLayer.push({event:'jptv_retailer_click',...data})}
 }));
})();
